import { useEffect } from "react";
import "./VericalAds.css";

export default function VerticalAdsDis() {
  useEffect(() => {
    try {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch (err) {
      console.log(err);
    }
  }, []);

  return (
    <div className="vertical-ad-wrapper">
      <div className="vertical-ad-label">Sponsored</div>

      <ins
        className="adsbygoogle"
        style={{ display: "block" }}
        data-ad-client="ca-pub-5162535306990850"
        data-ad-slot="3746920263"
        data-ad-format="auto"
        data-full-width-responsive="true"
      />
    </div>
  );
}